(ns common.opensearch.row
  #?(:clj
     (:require [clojure.edn :as edn])
     :cljs
     (:require [cljs.reader :as edn])))

(defn normalize-entity-id
  [row-value]
  (cond
    (number? row-value)
    row-value

    (string? row-value)
    (let [parsed-value (try
                         (edn/read-string row-value)
                         (catch #?(:clj Exception :cljs :default) _
                           nil))]
      (when (number? parsed-value)
        parsed-value))

    :else
    nil))

(defn entity-id
  [row-value]
  (cond
    (number? row-value)
    row-value

    (string? row-value)
    (normalize-entity-id row-value)

    (map? row-value)
    (or (some-> (get row-value "original.db/id") normalize-entity-id)
        (some-> (get row-value :original.db/id) normalize-entity-id)
        (some-> (get row-value "db/id") normalize-entity-id)
        (some-> (:db/id row-value) normalize-entity-id)
        (some-> (get row-value "id") normalize-entity-id)
        (some-> (:id row-value) normalize-entity-id))

    :else
    nil))

(defn flat-value
  "Return the value of the flat field with this alias from a search row, for
   example the alias \"oppo-status\" for the field `flat.oppo-status`. A row
   from a response has keyword keys, a row from a flat document has string keys,
   and a row may hold the dotted name `flat.alias`. Try each shape. Return nil
   when the row has no such field."
  [row alias]
  (when (map? row)
    (some (fn [path]
            (get-in row path))
          [[:flat (keyword alias)]
           ["flat" alias]
           [(keyword (str "flat." alias))]
           [(str "flat." alias)]])))
